<template>
    <a href="#" @click="openProfile">
        <i class="pi pi-user"></i>
        <div class="settings-item">
            <h6>Profile</h6>
        </div>
    </a>
</template>

<script setup>
import useUserComposable from '@/composables/UserComposable';
const { loggedUser } = useUserComposable();

import { useRouter } from 'vue-router';
const router = useRouter();

const openProfile = async () => {
    return router.push({ name: 'UserSpecificAnswersTable', params: { userId: loggedUser.value.id } });
};
</script>
